var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogBackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 20,
    fill: "url(#paint0_linear_87_69)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9125 48.0001C82.5529 48.0232 70.4233 53.0991 61.468 61.3507L54.268 54.4086C51.2199 51.4699 46.0084 53.5512 46.0084 57.7074V83.7651C46.0084 86.3415 48.1746 88.4301 50.8467 88.4301H77.8725C82.183 88.4301 84.3417 83.4053 81.2937 80.4663L72.8771 72.3512C79.0992 66.7339 87.1503 63.6224 95.7038 63.5512C114.331 63.3961 130.032 77.9305 129.871 96.4865C129.718 114.089 114.917 128.86 96.0042 128.86C87.7132 128.86 79.8771 126.007 73.7018 120.783C72.7457 119.974 71.3016 120.023 70.4021 120.89L62.4064 128.599C61.4242 129.546 61.4728 131.09 62.5036 131.988C71.3688 139.709 83.117 144.41 96.0042 144.41C123.616 144.41 146 122.828 146 96.2055C146 69.6132 123.493 47.9525 95.9125 48.0001Z",
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_69",
    x1: 96,
    y1: 0,
    x2: 96,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69B9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#286456"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogBackIcon);
export default __webpack_public_path__ + "static/media/log_back_icon.78519606c41b490ff06e0e567c4d5528.svg";
export { ForwardRef as ReactComponent };